import { RemoveRowActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/row'
import { Target } from '../../TargetsContext/types'
import { Permission } from '@cims-online/shared'
import { useTargetsContext } from '../../TargetsContext'
import { useRemoveAsphaltMixDesignTargetMutation } from 'schema'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { simpleRemoveNotification } from 'hooks/notificationHandler'

export function useRemove(): RemoveRowActionOptions<Target> {
  const { refetch } = useTargetsContext()
  const [remove] = useRemoveAsphaltMixDesignTargetMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      softRemoveLIMSAsphaltMixDesignTarget: {
        target: { name },
      },
    }) => simpleRemoveNotification(name),
  })
  return {
    permission: Permission.RemoveRestoreLIMSAsphaltMixDesignTarget,
    disabled: ({ percentages }) =>
      percentages.some(
        ({ mixDesign: { active, deleted } }) => !deleted && active
      )
        ? {
            message:
              'Targets cannot be removed if they are associated with any active Mix Designs',
          }
        : false,
    onRemove: async ({ id }) => {
      await remove({ variables: { id } })
      refetch()
    },
  }
}
